import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from "@angular/core";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { FormContainerModel } from "projects/sepidz-web-framework-shell/src/lib/tabular/form-container-model";
import { TabularService } from "projects/sepidz-web-framework-shell/src/lib/tabular/tabular.service ";
import { form_control } from "projects/sepidz-web-framework/src/lib/models";
import { Datatransfer } from "projects/sepidz-web-framework/src/lib/models/datatransfer.model";
import { Dictionary } from "projects/sepidz-web-framework/src/lib/models/dictionary";
import { IncrementalKind, SystemKind } from "projects/sepidz-web-framework/src/lib/models/enums";
import { FormControlTypes } from "projects/sepidz-web-framework/src/lib/models/form-base-control.model";
import { LookupService, ShowToastrService } from "projects/sepidz-web-framework/src/lib/services";
import { MisSetupService } from "projects/sepidz-web-framework/src/lib/services/missetup.service";
import { takeUntil } from "rxjs/operators";
import { InvVoucherKind } from "../../models/inv-voucher-kind.model";
@Component({
  selector: "ngx-inv-voucher-kind-form",
  templateUrl: "./inv-voucher-kind-form.component.html",
  styleUrls: ["./inv-voucher-kind-form.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InvVoucherKindFormComponent extends BaseFormComponent<InvVoucherKind> {
  activeTabTitle: string;
  DefaultValues: Dictionary = [];
  sellColumns: form_control[];
  sgColumns: form_control[];
  ReferenceVoucherKinds: form_control[];
  VoucherKindDetailLedgerKinds: form_control[];
  VoucherKindGoodss: form_control[];
  invDetailColumns: form_control[];
  public FormControlTypes = FormControlTypes;
  @Input() systemKind: SystemKind;

  constructor(
    sts: ShowToastrService,
    private datatransfer: Datatransfer,
    private lookupservice: LookupService,
    __id: FormContainerModel,
    private missetup: MisSetupService,
    protected selectorService: SelectorService,
    protected cd: ChangeDetectorRef,
    _tabsservice: TabularService
  ) {
    super(selectorService, cd);
    this.currentrow = this.datatransfer?.currentrow;
    this.apiName = this.datatransfer?.apiName;
    this.label = this.datatransfer?.label;
    this.areaName = this.datatransfer?.areaName;
    this._id = __id;
    this.tabsservice = _tabsservice;
  }
  async ngOnInit() {
    this.apiName = "InvVoucherKind";
    this.label = this.translate("ClientApp.BackOffice.INV.InvVoucherKind.InvVoucherKind");
    super.ngOnInit();
    if (this.currentrow && (this.currentrow as InvVoucherKind).Title) {
      this.label = (this.currentrow as InvVoucherKind).Title;
      this.tabsservice.setTabTitle(this._id.metadata.id, this.getFormTitle());
    } else {
      this.tabsservice.setTabTitle(this._id.metadata.id, this.getFormTitle());
    }
  }
  ngOnDestroy() {
    super.ngOnDestroy();
    this.selectorService.setHasDefaultValue("DefaultSubLedgerId", undefined);
    this.selectorService.setHasDefaultValue("WarehouseSubledgerId", undefined);
    this.selectorService.setHasDefaultValue("GoodsDetailLedgerInLevelId", undefined);
    this.selectorService.setHasDefaultValue("DetailLedgerInLevelId", undefined);
    this.DefaultValues = undefined;
    this.sellColumns = undefined;
    this.sgColumns = undefined;
    this.invDetailColumns = undefined;
    this.FormControlTypes = undefined;
    this.ReferenceVoucherKinds = undefined;
    this.VoucherKindDetailLedgerKinds = undefined;
    this.VoucherKindGoodss = undefined;
  }
  setdefault() {
    this.DefaultValues["InvVoucherKindId"] = 0;
    if (this.model.Active === undefined) this.model.Active = true;

    this.selectorService.setHasDefaultValue("DefaultSubLedgerId", false);
    this.selectorService.setHasDefaultValue("WarehouseSubledgerId", false);
    this.selectorService.setHasDefaultValue("GoodsDetailLedgerInLevelId", false);
    this.selectorService.setHasDefaultValue("DetailLedgerInLevelId", false);
    if (this.model.IsWarehouse === undefined) {
      if (this.selectorService.getHasDefaultValue("IsWarehouse") === undefined) this.model.IsWarehouse = true;
      else this.model.IsWarehouse = false;
    }
    if (!this.model.SystemKindId) {
      this.lookupservice
        .getLookupbyCode("GNR", "SystemKind", this.systemKind ? this.systemKind : SystemKind.INV)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((x) => {
          if (x) {
            this.model.SystemKindId = x.Id;
            this.model.SystemKindCode = x.Code;
            this.model.SystemKindTitle = x.Title;
            this.setValue("SystemKindId", x.Id);
          }
        });
    }
    if (!this.model.OrderByNumber) this.model.OrderByNumber = this.model.Code;
    if (!this.model.ReferenceVoucherKinds) this.model.ReferenceVoucherKinds = [];
    if (!this.model.VoucherKindDetailLedgerKinds) this.model.VoucherKindDetailLedgerKinds = [];
    if (!this.model.VoucherKindGoodss) this.model.VoucherKindGoodss = [];
    this.setDefaultValues();
  }
  addControl() {
    this.setValue("SystemKindId", this.model.SystemKindId);
  }

  setMaxCode() {
    this.httpCommonService
      .getMaxCode(this.apiName)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((data) => {
        if (!this.model) this.model = <InvVoucherKind>{};
        if (data) {
          this.model["Code"] = data as number;
          this.model.OrderByNumber = data as number;
        }
        this.setdefault();
        this.setFormGroup(this.model);
      });
  }
  setDefaultValues() {
    this.orignalColumns.forEach((x) => {
      if (x.controlType === FormControlTypes.checkbox && this.model[x.name] === undefined) this.model[x.name] = false;
    });
  }

  setColumnAttribute() {
    this.columns.forEach((x) => (x.isFloat = null));
    this.cd.markForCheck();
  }

  async setColumns() {
    this.httpCommonService
      .getControlsList(this.apiName.split("/")[0])
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((data) => {
        if (data) {
          this.orignalColumns = data as form_control[];
          this.columns = (data as form_control[]).filter(
            (f) => ((!f.areaName || f.areaName === "default") && f.formVisible) || (f.DetailControlModels && f.DetailControlModels[f.name].length > 0)
          );
          this.columns = this.columns.sort((a, b) => a.order - b.order);
          this.setColumnNumber(this.columns);
          this.sellColumns = (data as form_control[]).filter(
            (f) => (f.areaName === "sell" && f.formVisible) || (f.DetailControlModels && f.DetailControlModels[f.name].length > 0)
          );
          this.sellColumns = this.sellColumns.sort((a, b) => a.order - b.order);
          this.setColumnNumber(this.sellColumns, 5);

          this.sgColumns = (data as form_control[]).filter(
            (f) => (f.areaName === "SG" && f.formVisible) || (f.DetailControlModels && f.DetailControlModels[f.name].length > 0)
          );
          this.sgColumns = this.sgColumns.sort((a, b) => a.order - b.order);
          this.setColumnNumber(this.sgColumns, 5);

          this.invDetailColumns = (data as form_control[]).filter(
            (f) => (f.areaName === "Detail" && f.formVisible) || (f.DetailControlModels && f.DetailControlModels[f.name].length > 0)
          );
          this.invDetailColumns = this.invDetailColumns.sort((a, b) => a.order - b.order);

          this.ReferenceVoucherKinds = this.getDetailControlModels("ReferenceVoucherKinds");
          this.VoucherKindDetailLedgerKinds = this.getDetailControlModels("VoucherKindDetailLedgerKinds");
          this.VoucherKindGoodss = this.getDetailControlModels("VoucherKindGoodss");

          this.setdefault();
          this.setFormGroup(this.model);
        }
      });
  }
  onValueChangeByApiName($event) {
    if ($event && $event.apiName && $event.apiName.includes("Lookup") && $event.data && $event?.data?.Category?.includes("IncrementalKind")) {
      if (
        ($event.data["Code"] === IncrementalKind.Increment || $event.data["Code"] === IncrementalKind.Debtor) &&
        this.formGroup.get("HasWarehouseTransfer") &&
        this.formGroup.get("HasWarehouseTransfer").value !== true
      ) {
        this.setValue("HasJournalVoucher", true, true);
        this.setValue("HasJournalVoucherAuto", true, true);
        this.formGroup.controls["HasJournalVoucher"].enable();
        this.formGroup.controls["HasJournalVoucherAuto"].enable();
      }
      if ($event.data["Code"] === IncrementalKind.Neutral) {
        this.setValue("HasJournalVoucher", false, false);
        this.setValue("HasJournalVoucherAuto", false, false);
        this.formGroup.controls["HasJournalVoucher"].disable();
        this.formGroup.controls["HasJournalVoucherAuto"].disable();
      }
      if ($event.data["Code"] === IncrementalKind.Decrement) {
        this.setValue("HasJournalVoucher", true, true);
        this.formGroup.controls["HasJournalVoucher"].enable();
        if (this.model.IsWarehouse === true) {
          this.setValue("HasJournalVoucherAuto", false, false);
          this.formGroup.controls["HasJournalVoucherAuto"].disable();
        } else {
          this.setValue("HasJournalVoucherAuto", true, true);
          this.formGroup.controls["HasJournalVoucherAuto"].enable();
        }
      }
    }
  }
  beforupdate() {
    if (this.model.ReferenceVoucherKinds && this.model.ReferenceVoucherKinds.length <= 0) this.model.ReferenceVoucherKinds = null;
    else this.setValue("ReferenceVoucherKinds", this.model.ReferenceVoucherKinds);

    if (this.model.VoucherKindDetailLedgerKinds && this.model.VoucherKindDetailLedgerKinds.length <= 0)
      this.model.VoucherKindDetailLedgerKinds = null;
    else this.setValue("VoucherKindDetailLedgerKinds", this.model.VoucherKindDetailLedgerKinds);
    if (this.model.VoucherKindGoodss && this.model.VoucherKindGoodss.length <= 0) this.model.VoucherKindGoodss = null;
    else this.setValue("VoucherKindGoodss", this.model.VoucherKindGoodss);
  }

  isActveTab(title: string) {
    return this.activeTabTitle === title;
  }
  selectTab($event) {
    this.activeTabTitle = $event.tabTitle;
  }
  getDetailControlModels(keyName: string) {
    let columns = this.orignalColumns.find((x) => x.name === keyName).DetailControlModels[keyName];
    for (var i = 0; i < columns.length; i++) {
      if (columns[i]["apiName"]) columns[i]["isMulti"] = true;
    }
    return columns;
  }
  close() {
    this.accountService.authService.getMvcController();
    super.close();
  }

  onvalueChangeWithName($event) {
    if ($event && $event?.name === "HasOpositeParty" && $event.value) {
      this.model.HasWarehouseTransfer = !$event.value;
      this.setValue("HasWarehouseTransfer", this.model.HasWarehouseTransfer);
    }
    if ($event && $event?.name === "HasWarehouseTransfer" && $event.value) {
      this.model.HasOpositeParty = !$event.value;
      this.setValue("HasOpositeParty", this.model.HasOpositeParty);

      this.setValue("HasJournalVoucher", false, false);
      this.setValue("HasJournalVoucherAuto", false, false);
      this.formGroup.controls["HasJournalVoucher"].disable();
      this.formGroup.controls["HasJournalVoucherAuto"].disable();
    }

    this.cd.markForCheck();
  }
}
